import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/Components/ui/dropdown-menu";
import { CharterIcon, CheckIcon, DeleteIcon, DeliverableIcon, DependenciesIcon, IndentIcon, MilestoneIcon, OutdentIcon, PackageMilestoneIcon, StatusReportIcon, TaskIcon, UndoIcon, RedoIcon } from "@/Components/ui/Icons/TooltipIcon";
import { useTaskMenuLogic } from "./hooks/useTaskMenuLogic";
import { useContext } from "react";
import { PlanBuilderContext } from "../Plan";


export function QuickActions() {
    const plan = useContext(PlanBuilderContext);

    const {
        allowSetDependencies,
        allowRemove,
        allowCascade,
        allowSelected,
        allowDependents,
        canIndent,
        canOutdent,
        allowDelete,
        canComplete,
        handleSetDependencies,
        handleSetTaskType,
        handleSetFlag,
        handleDelete,
        handleCompleteTask,
    } = useTaskMenuLogic();

    return (
        <div className="flex flex-row space-x-2 min-w-[520px]">
            <div className="mx-auto">
                <button onClick={() => handleCompleteTask()} disabled={!canComplete.canComplete} className="p-2 rounded-md"><CheckIcon tooltip={canComplete.canComplete ? "Mark as Completed" : canComplete.reason}  className={!canComplete.canComplete ? "text-gray-500" : ""} /></button>
                <button onClick={() => plan.indentTasksUnderParent()} className={"p-2 rounded-md"} disabled={!canIndent.canIndent} ><IndentIcon tooltip={canIndent.canIndent ? (plan.selectedTaskIDs.length > 1 ? "Indent Tasks" : "Indent Task") : canIndent.reason} className={(!canIndent.canIndent ? "text-gray-500" : "")} /></button>
                <button onClick={() => plan.outdentTasksFromParent()} className={"p-2 rounded-md"} disabled={!canOutdent.canOutdent} ><OutdentIcon tooltip={ canOutdent.canOutdent ? (plan.selectedTaskIDs.length > 1 ? "Outdent Tasks" : "Outdent Task") : canOutdent.reason} className={(!canOutdent.canOutdent ? "text-gray-500" : "")} /></button>
                <DropdownMenu>
                    <DropdownMenuTrigger disabled={!allowSetDependencies} asChild>
                        <button className="p-2 rounded-md focus:outline-none"><DependenciesIcon tooltip="Set Dependencies" className={!allowSetDependencies ? "text-gray-500" : ""} /></button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-48">
                        {allowCascade && <DropdownMenuItem onClick={() => handleSetDependencies("cascade")}>Cascade Dependencies</DropdownMenuItem>}
                        {allowSelected && <DropdownMenuItem onClick={() => handleSetDependencies("selected")} >Selected are dependencies of highlighted Task</DropdownMenuItem>}
                        {allowDependents && <DropdownMenuItem onClick={() => handleSetDependencies("dependents")} >Selected depend on highlighted Task</DropdownMenuItem>}
                        {allowRemove && <DropdownMenuItem onClick={() => handleSetDependencies("remove")}>Remove Dependencies</DropdownMenuItem>}
                    </DropdownMenuContent>
                </DropdownMenu>
                <DropdownMenu>
                    <DropdownMenuTrigger disabled={!plan.selectedTaskID} asChild>
                        <button className="p-2 rounded-md focus:outline-none"><TaskIcon tooltip="Set Type" className={!plan.selectedTaskID ? "text-gray-500" : ""} /></button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-48">
                        <DropdownMenuItem onClick={() => handleSetTaskType("task")}><TaskIcon />Task</DropdownMenuItem>
                        <DropdownMenuItem onClick={() => handleSetTaskType("deliverable")}><DeliverableIcon />Deliverable</DropdownMenuItem>
                        <DropdownMenuItem onClick={() => handleSetTaskType("milestone")}><MilestoneIcon />Milestone</DropdownMenuItem>
                        <DropdownMenuItem onClick={() => handleSetTaskType("deliverableMilestone")}><PackageMilestoneIcon />Deliverable Milestone</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
                <DropdownMenu>
                    <DropdownMenuTrigger disabled={!plan.selectedTaskID} asChild>
                        <button className="p-2 rounded-md focus:outline-none"><CharterIcon tooltip="Set Flags" className={!plan.selectedTaskID ? "text-gray-500" : ""} /></button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-48">
                        <DropdownMenuItem onClick={() => handleSetFlag("statusReport")}><StatusReportIcon />Display on Status Report</DropdownMenuItem>
                        <DropdownMenuItem onClick={() => handleSetFlag("charter")}><CharterIcon />Display on Charter</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
                <button className="p-2 rounded-md focus:outline-none"><UndoIcon /></button>
                <button className="p-2 rounded-md focus:outline-none"><RedoIcon /></button>
                <button className="p-2 rounded-md focus:outline-none" onClick={() => handleDelete()} disabled={!allowDelete}><DeleteIcon className={allowDelete ? "" : "text-gray-500"} tooltip={plan.selectedTaskIDs.length > 1 ? "Delete Tasks" : "Delete Task"} /></button>
            </div>
        </div>
    )
}